import { useCallback, useSyncExternalStore } from "react";
import {
  definirSomDoAparelho,
  ouvirSomDoAparelho,
  somDoAparelhoLigado,
} from "@/lib/avisos/somDoAparelho";

/** O interruptor "Som neste aparelho" (parte D1): o sino e a tela de preferências
 *  mostram o MESMO valor, e a mudança de uma aba chega às outras. */
export function useSomDoAparelho(): [boolean, (ligado: boolean) => void] {
  const ligado = useSyncExternalStore(
    ouvirSomDoAparelho,
    () => somDoAparelhoLigado(),
    () => true
  );
  const definir = useCallback((valor: boolean) => definirSomDoAparelho(valor), []);
  return [ligado, definir];
}
